<template>
  <div>
    <v-card class="mx-auto qam-calc-box">
      <v-card-text
        class="font-weight-bold text-center"
        style="margin-bottom: -25px !important"
      >
        <h3 style="color: #000000">{{ selectedLang.PreTile1 }}</h3>
      </v-card-text>
      <v-card-actions>
        <v-row>
          <v-col cols="12" sm="3">
            <v-btn
              v-bind:class="kiOfCl == 'del' ? 'selected-btn' : 'unselected-btn'"
              block
              v-on:click="setCase('del')"
              :disabled="stage1"
              elevation="2"
              x-large
              dark
            >
              {{ selectedLang.PreTile2 }}
            </v-btn>
          </v-col>
          <v-col cols="12" sm="3">
            <v-btn
              v-bind:class="kiOfCl == 'can' ? 'selected-btn' : 'unselected-btn'"
              block
              v-on:click="setCase('can')"
              :disabled="stage1"
              elevation="2"
              x-large
              dark
            >
              {{ selectedLang.PreTile3 }}
            </v-btn>
          </v-col>
          <v-col cols="12" sm="3">
            <v-btn
              v-bind:class="
                kiOfCl == 'resc' ? 'selected-btn' : 'unselected-btn'
              "
              block
              v-on:click="setCase('resc')"
              :disabled="stage1"
              elevation="2"
              x-large
              dark
            >
              {{ selectedLang.PreTile4 }}
            </v-btn>
          </v-col>
          <v-col cols="12" sm="3">
            <v-btn
              v-bind:class="kiOfCl == 'noc' ? 'selected-btn' : 'unselected-btn'"
              block
              v-on:click="setCase('noc')"
              :disabled="stage1"
              elevation="2"
              x-large
              dark
            >
              {{ selectedLang.PreTile5 }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
    <v-card v-if="stage1" class="mx-auto qam-calc-box">
      <v-card-text class="font-weight-bold text-center"
        ><h3 style="color: #000000">
          {{ infoText1 }}
        </h3></v-card-text
      >
      <v-card-actions>
        <v-row>
          <v-col>
            <div class="my-2">
              <v-btn
                v-bind:class="sw == 'sc' ? 'selected-btn' : 'unselected-btn'"
                block
                v-on:click="setWay('sc')"
                :disabled="stage2"
                dark
              >
                {{ selectedLang.PreTile13 }}
              </v-btn>
            </div>
          </v-col>
          <v-col>
            <div class="my-2">
              <v-btn
                v-bind:class="sw == 'lw' ? 'selected-btn' : 'unselected-btn'"
                block
                v-on:click="go2Long"
                :disabled="stage2"
                dark
              >
                {{ selectedLang.PreTile14 }}
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-card-actions>
      <v-card-text v-if="!stage2" class="font-weight-bold text-center">
        <p>{{ selectedLang.PreTile12a }}</p></v-card-text
      >
    </v-card>
    <v-card v-if="stage2" class="mx-auto qam-calc-box">
      <v-card-text class="font-weight-bold text-center"
        ><h3 style="color: #000000">{{ infoText2 }}</h3>
      </v-card-text>
      <v-card-actions>
        <v-row v-if="kiOfCl != 'resc'">
          <v-col>
            <div class="my-2">
              <v-btn
                v-bind:class="distance == 1 ? 'selected-btn' : 'unselected-btn'"
                block
                v-on:click="setDistance(1)"
                :disabled="stage3"
                dark
              >
                {{ selectedLang.PreTile18 }}
              </v-btn>
            </div>
          </v-col>
          <v-col>
            <div class="my-2">
              <v-btn
                v-bind:class="distance == 2 ? 'selected-btn' : 'unselected-btn'"
                block
                v-on:click="setDistance(2)"
                :disabled="stage3"
                dark
              >
                {{ selectedLang.PreTile19 }}
              </v-btn>
            </div>
          </v-col>
          <v-col>
            <div class="my-2">
              <v-btn
                v-bind:class="distance == 3 ? 'selected-btn' : 'unselected-btn'"
                block
                v-on:click="setDistance(3)"
                :disabled="stage3"
                dark
              >
                {{ selectedLang.PreTile20 }}
              </v-btn>
            </div>
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col>
            <div class="my-2">
              <v-btn
                v-bind:class="resCase == 1 ? 'selected-btn' : 'unselected-btn'"
                block
                v-on:click="setResCase(1)"
                :disabled="stage3"
                dark
              >
                {{ selectedLang.PreTile21 }}
              </v-btn>
            </div>
          </v-col>
          <v-col>
            <div class="my-2">
              <v-btn
                v-bind:class="resCase == 2 ? 'selected-btn' : 'unselected-btn'"
                block
                v-on:click="setResCase(2)"
                :disabled="stage3"
                dark
              >
                {{ selectedLang.PreTile22 }}
              </v-btn>
            </div>
          </v-col>
          <v-col>
            <div class="my-2">
              <v-btn
                v-bind:class="resCase == 3 ? 'selected-btn' : 'unselected-btn'"
                block
                v-on:click="setResCase(3)"
                :disabled="stage3"
                dark
              >
                {{ selectedLang.PreTile23 }}
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
    <template v-if="stage1">
      <v-row>
        <v-col cols="12">
          <v-btn color="warning" block v-on:click="restart()" dark>
            {{ selectedLang.ComparisonTile13 }}
          </v-btn>
        </v-col>
      </v-row>
    </template>
    <template v-if="stage3">
      <v-card class="mx-auto qam-calc-box">
        <v-card-text class="font-weight-bold text-center">
          <h3 style="color: #000000">{{ selectedLang.ComparisonTile1 }}</h3>
          <h5 style="color: #000000">
            {{ infoText3 }}
          </h5></v-card-text
        >
      </v-card>
      <offer-table v-bind:value="dA"></offer-table>
    </template>
  </div>
</template>

<script>
import OfferTable from "./OfferTable.vue";
export default {
  components: {
    OfferTable,
  },
  name: "CoreTile",
  data: () => ({
    kiOfCl: 0,
    sw: "",
    distance: 0,
    stage1: false,
    stage2: false,
    stage3: false,
    selectedLang: "",
    issueGenitive: "",
    cashbackType: "",
    infoText1: "",
    infoText2: "",
    infoText3: "",
    moreInformation: "",
    resCase: "",
    dA: {},
  }),
  mounted: function () {
    const queryString = window.location.search;
    var urlParams = new URLSearchParams(queryString);
    var slang = "";
    if (urlParams.has("slang")) {
      slang = urlParams.get("slang");
    } else {
      slang = sessionStorage.getItem("slang");
    }

    if (slang == null) {
      slang = navigator.language;
    }

    this.dA.lang = slang;
    this.getText(slang);
  },
  methods: {
    setCase: function (val) {
      this.kiOfCl = val;
      this.stage1 = true;
      switch (val) {
        case "del":
          this.issueGenitive = this.selectedLang.PreTile6;
          this.$ga.event("Rechner", "Klick Verspaetung");
          //window._fbq('trackCustom', 'Verspaetung');
          break;
        case "can":
          this.issueGenitive = this.selectedLang.PreTile7;
          this.$ga.event("Rechner", "Klick Ausfall");
          //window._fbq('trackCustom', 'Ausfall');
          break;
        case "resc":
          this.issueGenitive = this.selectedLang.PreTile8;
          this.$ga.event("Rechner", "Klick Storno");
          //window._fbq('trackCustom', 'Storno');
          break;
        case "noc":
          this.issueGenitive = this.selectedLang.PreTile9;
          this.$ga.event("Rechner", "Klick NB");
          //window._fbq('trackCustom', 'Nichtbefoerderung');
          break;
      }

      if (val == "resc") {
        this.cashbackType = this.selectedLang.PreTile11;
        this.moreInformation = this.selectedLang.PreTile16;
      } else {
        this.cashbackType = this.selectedLang.PreTile10;
        this.moreInformation = this.selectedLang.PreTile15;
      }

      this.infoText1 = this.formatDBText(this.selectedLang.PreTile12, {
        issueGenitive: this.issueGenitive,
        cashbackType: this.cashbackType,
      });
      this.infoText2 = this.formatDBText(this.selectedLang.PreTile17, {
        moreInformation: this.moreInformation,
        cashbackType: this.cashbackType,
      });
      this.infoText3 = this.cashbackType2 = this.formatDBText(
        this.selectedLang.ComparisonTile2,
        {
          cashbackType: this.cashbackType,
        }
      );
      window.scrollBy({ top: 400, left: 0, behavior: "smooth" });
    },
    setWay: function (val) {
      this.$ga.event("Rechner", "gotoshortcalc");
      this.sw = val;
      this.stage2 = true;
      window.scrollBy({ top: 400, left: 0, behavior: "smooth" });
    },
    setDistance: function (val) {
      this.distance = val;
      this.stage3 = true;
      this.dA.distance = val;
      window.scrollBy({ top: 600, left: 0, behavior: "smooth" });
    },
    setResCase: function (val) {
      this.resCase = val;
      this.stage3 = true;
      this.dA.resCase = true;
      this.dA.resCaseVal = val;
      window.scrollBy({ top: 400, left: 0, behavior: "smooth" });
    },
    setText: function (val) {
      this.dA.ComparisonTile3 = val.ComparisonTile3;
      this.dA.ComparisonTile4 = val.ComparisonTile4;
      this.dA.ComparisonTile5 = val.ComparisonTile5;
      this.dA.ComparisonTile6 = val.ComparisonTile6;
      this.dA.ComparisonTile7 = val.ComparisonTile7;
      this.dA.ComparisonTile8 = val.ComparisonTile8;
      this.dA.ComparisonTile9 = val.ComparisonTile9;
      this.dA.ComparisonTile10 = val.ComparisonTile10;
      this.dA.ComparisonTile11 = val.ComparisonTile11;
      this.dA.ComparisonTile12 = val.ComparisonTile12;
    },
    restart: function () {
      this.kiOfCl = 0;
      this.sw = "";
      this.distance = 0;
      this.stage1 = false;
      this.stage2 = false;
      this.stage3 = false;
    },
    getText: async function (value) {
      fetch(
        "https://www.qam-qam.com/wp-content/themes/qamqam%200.1/own/func/getLang.php"
      )
        .then((res) => res.json())
        .then((res) => {
          let lang = value.substring(0, 2);
          if (lang == "de") {
            this.selectedLang = res.de;
            this.setText(res.de);
          } else {
            this.selectedLang = res.en;
            this.setText(res.en);
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => (this.isLoading = false));
    },
    formatDBText(str, values) {
      let result;
      let reg = /(\w+.?\w+)(?= }})/g;
      while ((result = reg.exec(str)) !== null) {
        let key = String(str).match(reg)[0];
        if (Object.keys(values).includes(key)) {
          str = str.replace("{{ " + key + " }}", values[key]);
        }
      }
      result = str;
      return result;
    },
    go2Long() {
      this.$ga.event("Rechner", "gotolongcalc");
      window.open(
        "https://www.qam-qam.com/fluggastportale/entschaedigungsrechner/",
        "_blank"
      );
    },
  },
};
</script>
